import { gql } from '@apollo/client';

export const GET_IT_APPLICATION_WITH_WORKAROUNDS = gql`
  query GetITApplicationWithWorkarounds($uuid: ID!, $locationUUID: ID) {
    getITApplicationWithWorkarounds(uuid: $uuid, locationUUID: $locationUUID) {
      uuid
      name
      description
      tier {
        name
        color
      }
      mto
      rpo
      rto
      sla
      businessFunctions {
        uuid
        name
        runtimeHours
        workaroundDescription
        isDefined
        workaroundTimelineCompliance {
          slaCompliant
          rtoCompliant
          mtoCompliant
          rpoCompliant
        }
      }
      qualitativeFactors {
        uuid
        name
        runtimeHours
        workaroundDescription
        isDefined
        workaroundTimelineCompliance {
          slaCompliant
          rtoCompliant
          mtoCompliant
          rpoCompliant
        }
      }
      processAreas {
        uuid
        name
        runtimeHours
        workaroundDescription
        isDefined
        workaroundTimelineCompliance {
          slaCompliant
          rtoCompliant
          mtoCompliant
          rpoCompliant
        }
      }
    }
  }
`;
